import {usePatientTherapySequenceContext} from '@/shared/contexts/patient-therapy-sequence-context'
import {Alert, Box, Span, Table, Tabs, Text} from '@chakra-ui/react'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {DetailCard} from '@cypro/ui/components/ui/detail-card'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'
import {useTranslate} from '@tolgee/react'
import {PrescriptionTableHeader, PrescriptionTableRow} from '../sequence-row'
export function ProtocolTab() {
  const {t} = useTranslate('common')
  const {sequence} = usePatientTherapySequenceContext()
  const protocol = sequence.protocol
  const protocolSequences = sequence.patientProtocol?.therapySequence || []

  const cycleGroups = groupByCycle([...protocolSequences])

  return (
    <Tabs.Content value="protocol" flex="1" minHeight="0" display="flex" flexDirection="column" spaceY="5">
      {protocol?.name && (
        <Text as="h3" fontSize="sm" fontWeight="medium">
          {protocol.name}
        </Text>
      )}

      {protocol?.notes && (
        <Alert.Root size="sm" colorPalette="orange" borderRadius="lg">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Title fontSize="xs" spaceX="2">
              <Span>{t('protocol_information')}</Span>{' '}
              <Span fontWeight="normal" color="fg.muted">
                {t('protocol_note_applies_to_all')}
              </Span>
            </Alert.Title>
            <Alert.Description fontSize="xs">{protocol.notes}</Alert.Description>
          </Alert.Content>
        </Alert.Root>
      )}

      <DetailCard.Inner width="100%" p="0">
        <Table.Root size="sm" overflow="hidden" textStyle="xs" interactive={false}>
          <PrescriptionTableHeader />

          {!cycleGroups.length && (
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan={4}>
                  <EmptyState title={t('no_therapy_sequences')} />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          )}

          {cycleGroups.map(([cycle, sequences]) => {
            return (
              <Table.Body key={cycle}>
                <Table.Row bg="bg.subtle">
                  <Table.Cell colSpan={4}>
                    <Box as="span" display="flex" gap="2" alignItems="baseline" fontWeight="medium">
                      {t('cycle_x', {value: cycle})}
                    </Box>
                  </Table.Cell>
                </Table.Row>

                {sequences.map(seq => (
                  <PrescriptionTableRow key={seq.id} sequence={seq} isCurrent={seq.id === sequence.id} />
                ))}
              </Table.Body>
            )
          })}
        </Table.Root>
      </DetailCard.Inner>
    </Tabs.Content>
  )
}

function groupByCycle(sequences: PatientTherapySequence[]) {
  const groups = new Map<number, PatientTherapySequence[]>()

  for (const sequence of sequences) {
    const cycle = sequence.cycle || 0
    const existing = groups.get(cycle) || []
    existing.push(sequence)
    groups.set(cycle, existing)
  }

  return [...groups.entries()].toSorted(([a], [b]) => a - b)
}
